import { omsActionType } from "./oms.action";

/**
 * @deprecated - [fabric-deprecated]
 */
export const omsMessageContext = {
	getAlerts: omsActionType.GET_ALERTS,
	getNotificationsByStatus: omsActionType.GET_NOTIFICATIONS_BY_STATUS,
	getNotificationsInfo: omsActionType.GET_NOTIFICATIONS_INFO,
	getUserSettings: omsActionType.GET_USER_SETTINGS,
	updateMessage: omsActionType.UPDATE_MESSAGE,
	updateUserSettings: omsActionType.UPDATE_USER_SETTINGS,
};
